var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xs-12 beware"},[_c('span',[_vm._v(_vm._s(_vm.trans('subscription.subscribable_groupings.beware_edit')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }